import React from 'react';
import { Link } from 'react-router-dom';

import { viewMessagesRoute } from 'App/common/routeLookup';
import HelpIcon from './icons/HelpIcon';
import UserIcon from './icons/UserIcon';
import SessionTimer from './icons/SessionTimer';
import AlertsCenterHeader from 'App/components/AlertsCenter/AlertsCenterIcon';
import useFetchMessageCountQuery from 'App/hooks/useFetchMessageCountQuery';

const IconBar = () => {
    const { data } = useFetchMessageCountQuery();

    const count = data?.count || 0;
    return (
        <div id="icon-bar" className="icon-bar">
            <UserIcon />
            <AlertsCenterHeader />
            <Link className="icon icon-envelope" to={viewMessagesRoute} aria-label="View Messages">
                <i className="fas fa-fw fa-envelope" />
                {count ? (
                    <span className="message-counter-box">
                        <span className="message-counter">{count}</span>
                    </span>
                ) : null}
            </Link>
            <HelpIcon />
            <SessionTimer />
        </div>
    );
};

export default IconBar;
